import { HelloRetailFiltersMap, HelloretailProductType } from "@/data/types/HelloRetail";
import { DEFAULT_CURRENCY } from "@/data/config/DEFAULTS";

export const dataMap = (products: any[]) => {
    return products?.map((p: any) => {
        return {
            name: p?.title,
            fullImage: p?.imgUrl,
            thumbnail: p?.imgUrl,
            productPrice: {
                min: p?.price ?? null,
                offer: p?.price ?? null,
                list: p?.oldPrice ?? null,
                currency: p?.currency ?? DEFAULT_CURRENCY
            },
            partNumber: p?.productNumber,
            ean: p?.ean,
            seo: {
                href: p?.url?.split("#")?.at(0)
            },
            trackingCode: p?.trackingCode
        } as HelloretailProductType
    })
}

export const sortFilterOptionsBySectionState = (
    filters: HelloRetailFiltersMap = {}
) =>
    Object.fromEntries(
        Object.entries(filters).map(([key, values]) => {
            const hasSelected = values.some(v => v.selected);
            return [
                key,
                hasSelected
                    ? [...values].sort((a, b) => Number(b.selected) - Number(a.selected))
                    : values
            ]
        })
    );

export const getFiltersShowMore = (
    filters: HelloRetailFiltersMap,
    filterKeys: string[]
): Record<string, boolean> => {
    return filterKeys.reduce<Record<string, boolean>>((acc, key) => {
        const options = filters[key] ?? [];
        const hasSelected = options.some(opt => opt.selected === true);

        if (!hasSelected && options.length > 10) {
            acc[key] = true;
        }

        return acc;
    }, {});
};